import {FieldJson, FormJson} from 'edocatbase/Form';
import {assocPath} from 'ramda';

export interface CBDependItem {
    url: string;
    valueFrom: string;
    valueUpdatedBy: string[];
    optionsUpdateBy: string[];
}

export const getCustomFieldValue = (anyValue: any | null): string => {
    if (!anyValue) {
        return '';
    }
    if (typeof anyValue === 'object') {
        if (typeof anyValue?.value === 'string') {
            return anyValue.value;
        }
        if (typeof anyValue?.toJSON === 'function') {
            return anyValue.toJSON();
        }
    }
    return anyValue.toString();
};

export const getValidConfig = (fields: { [key: string]: FieldJson }): Record<string, CBDependItem> | null => {
    const dependencies: Record<string, CBDependItem> = window?.__FORM_CONFIG__?.cbDepend;
    if (!dependencies) return null;

    let configFiltered: Record<string, CBDependItem> = {};
    for (const [depKey, depValue] of Object.entries(dependencies)) {
        let hasAll = true;
        hasAll &&= !!fields[depKey];
        if (depValue?.optionsUpdateBy) {
            depValue.optionsUpdateBy.forEach((src: any) => {
                hasAll &&= !!fields[src];
            });
        } else if (depValue?.valueUpdatedBy) {
            depValue.valueUpdatedBy.forEach((src: any) => {
                hasAll &&= !!fields[src];
            });
        } else {
            hasAll = false;
        }

        if (hasAll) {
            configFiltered[depKey] = dependencies[depKey];
        }
    }
    return configFiltered;
};

const add = <K, V>(map: Map<K, Set<V>>, key: K, value: V): Set<V> => {
    let aSet: Set<V>
    if (map.has(key)) {
        aSet = map.get(key) as Set<V>;
    } else {
        aSet = new Set<V>()
        map.set(key, aSet)
    }
    aSet.add(value);
    return aSet;
};

export const customModFormJson = (formJson: FormJson, dependencies: Record<string, CBDependItem>) => {
    const optionsTargets = new Map<string, Set<string>>();

    for (const [depKey, depValue] of Object.entries(dependencies)) {
        if (depValue?.optionsUpdateBy) {
            depValue.optionsUpdateBy.forEach((tgtKey: any) => {
                const currentValue: any = (formJson?.fields[tgtKey]?.value);
                const initialValue=getCustomFieldValue(currentValue);

                formJson = assocPath(["fields", depKey, "control", "params", "customQuery"], {
                    fetchUrl: depValue.url,
                    srcKey: tgtKey,
                    srcValue: initialValue
                }, formJson);
                add(optionsTargets, tgtKey, depKey);
            });
        }

        if (depValue?.valueUpdatedBy) {
            depValue.valueUpdatedBy.forEach((tgtKey: any) => {
                formJson = assocPath(["fields", tgtKey, "control", "params", "customQueryUpdateValue"], {
                    target: depKey,
                    source: depValue.valueFrom
                }, formJson);
            });
        }
    }

    for (const [tgtKey, tgtValues] of optionsTargets.entries()) {
        formJson = assocPath(["fields", tgtKey, "control", "params", "customQueryUpdateOptionsTarget"], [...tgtValues], formJson);
    }

    return formJson;
}
  